import React from 'react';

import FlexLink from '@components/FlexLink';

const GetInTouch = () => {
  return (
    <div className="mx-auto max-w-[1728px]">
      <div className="mt-112 bg-grayscale-beige px-12 py-72">
        <div className="mx-auto flex max-w-container-lg justify-center">
          <div className="flex w-full flex-col items-start justify-around sm:w-[90%]">
            <h3 className="mt-0 font-suisse-intl-mono text-headline-lg text-black">Get in touch</h3>
            <div className="flex flex-wrap gap-72 sm:gap-112">
              <p className="m-0 max-w-full sm:max-w-[360px]">
                Contact our events team directly if you’re interested in speaking at one of our
                future events,{' '}
                <FlexLink
                  className="underline hover:text-primary-magenta"
                  href="mailto:events@theinformation.com"
                >
                  events@theinformation.com
                </FlexLink>
                .
              </p>
              <p className="m-0">
                For sponsorship opportunities, email{' '}
                <FlexLink
                  href="mailto:sponsorships@theinformation.com"
                  className="block underline hover:text-primary-magenta"
                >
                  sponsorships@theinformation.com
                </FlexLink>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
